import { render, staticRenderFns } from "./ConfirmSentModal.vue?vue&type=template&id=25310af9"
import script from "./ConfirmSentModal.vue?vue&type=script&lang=js"
export * from "./ConfirmSentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports